import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App/App';
import * as serviceWorker from './serviceWorker';
import { StateProvider } from "./StateProvider";
import reducer, { initialState } from "./reducer";
import { LanguageProvider } from './LanguageProvider';


ReactDOM.render(
  <LanguageProvider>
  <StateProvider initialState={initialState} reducer={reducer}>
    <App />
    </StateProvider>
  </LanguageProvider>
  ,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
